import { noop } from '@chillibean/component-library';

import { Cohort } from '../../models';
import { createCohort, deleteCohort, getCohorts, updateCohort } from '../../services';
import * as actionTypes from './types';

export const setCohortsData = (value) => ({
  type: actionTypes.SET_COHORTS_DATA,
  value: value,
});

export const setCohortActionData = (value) => ({
  type: actionTypes.SET_COHORT_ACTION_DATA,
  value: value,
});

export const fetchCohorts = () => async (dispatch, getState) => {
  const { account, authenticityToken } = getState().internalReducer.internal;
  dispatch(setCohortsData({ data: [], error: null, loading: true }));

  try {
    const data = await getCohorts({
      accountId: account.id,
      authenticityToken: authenticityToken,
    });

    dispatch(setCohortsData({ data: data.map((cohort) => new Cohort(cohort)), error: null, loading: false }));
  } catch (error) {
    dispatch(setCohortsData({ data: [], error: error, loading: false }));
  }
};

export const addCohort =
  ({ cohortData, onError = noop, onSuccess = noop }) =>
  async (dispatch, getState) => {
    const { account, authenticityToken } = getState().internalReducer.internal;
    const { data: cohorts } = getState().cohortsReducer.cohorts;
    dispatch(setCohortActionData({ error: null, loading: true }));

    try {
      const data = await createCohort({
        accountId: account.id,
        authenticityToken: authenticityToken,
        data: cohortData,
      });

      dispatch(setCohortsData({ data: [...cohorts, new Cohort(data)], error: null, loading: false }));
      dispatch(setCohortActionData({ error: null, loading: false }));
      onSuccess();
    } catch (error) {
      dispatch(setCohortActionData({ error: error, loading: false }));
      onError(error);
    }
  };

export const modifyCohort =
  ({ cohortData, id, onError = noop, onSuccess = noop }) =>
  async (dispatch, getState) => {
    const { account, authenticityToken } = getState().internalReducer.internal;
    const { data: cohorts } = getState().cohortsReducer.cohorts;
    dispatch(setCohortActionData({ error: null, loading: true }));

    try {
      const data = await updateCohort({
        accountId: account.id,
        authenticityToken: authenticityToken,
        data: cohortData,
        id: id,
      });
      const modifiedCohorts = cohorts.map((cohort) => (cohort.id === data.id ? new Cohort(data) : cohort));

      dispatch(setCohortsData({ data: modifiedCohorts, error: null, loading: false }));
      dispatch(setCohortActionData({ error: null, loading: false }));
      onSuccess();
    } catch (error) {
      dispatch(setCohortActionData({ error: error, loading: false }));
      onError(error);
    }
  };

export const removeCohort =
  ({ id, onSuccess = noop, onError = noop }) =>
  async (dispatch, getState) => {
    const { account, authenticityToken } = getState().internalReducer.internal;
    dispatch(setCohortActionData({ error: null, loading: true }));

    try {
      const data = await deleteCohort({
        accountId: account.id,
        authenticityToken: authenticityToken,
        id: id,
      });
      dispatch(setCohortsData({ data: data.map((cohort) => new Cohort(cohort)), error: null, loading: false }));
      dispatch(setCohortActionData({ error: null, loading: false }));
      onSuccess();
    } catch (error) {
      dispatch(setCohortActionData({ error: error, loading: false }));
      onError(error);
    }
  };
